export default __webpack_public_path__ + "static/media/footer_logo.4801867c.svg";